<template>
    <header class="mdl-layout__header">
        <div class="mdl-layout__header-row">
            <div v-if="user != defaultUser" id="userlog">
                <span id="username">{{user}}</span>
                <span id="logout" class="material-icons" title="Déconnexion" @click='logout()'>power_settings_new</span>
            </div>
            <div id="version">version {{myVersion}}</div>
        </div>
        <!-- Menu -->
        <div id="div_menu" class="mdl-layout__tab-bar-container "> <!--<%--mdl-layout__tab-bar mdl-js-ripple-effect--%>-->
			<div id="div_btn_showRMenu" :class="divBtnRMenuClass">
				<button id=btn_showRMenu class="mdl-button mdl-js-button mdl-button--icon"
				@click="isRMenuActive = !isRMenuActive;">
  					<i class="material-icons">more_vert</i>
				</button>
			</div>
			<ul id="menuPrincipal" v-if="user != defaultUser" for="btn_showRMenu">
				<li class="elementsMenu"><router-link @click='desactiveRMenu()' class="lienActif" to="/accueil">Accueil</router-link>
					<ul class="MenuDropdown">
						<li><router-link @click='desactiveRMenu()' :to="'/users/' + this.$store.state.currentUser.id">Profil</router-link></li>
					</ul>
				</li>
				<li class="elementsMenu"  v-if="role == 'SUPERADMIN' ||  role == 'ADMIN'"><router-link @click='desactiveRMenu()' class="lienActif" :to="toAdmin()">Administration</router-link>
					<ul class="MenuDropdown" v-if="role == 'SUPERADMIN'">
						<li><router-link @click='desactiveRMenu()' to="/clients">Liste des clients</router-link></li>
						<li><router-link @click='desactiveRMenu()' :to="{ name: 'SelectDicoSetting', params: { mode: 'superadmin' }, query: { mode: 'superadmin' }}">Liste de toutes les configurations</router-link></li>
					</ul>
				</li>
				<li class="elementsMenu"><a class="lienActif" href="#">Expert linguistique</a>
					<ul class="MenuDropdown">
						<li><router-link @click='desactiveRMenu()' to="/selectSetting" :id="configID()" v-if="showConfig()">Liste des configurations</router-link></li>
						<li><router-link @click='desactiveRMenu()' to="/dictionary">Dictionnaires d'orthographe</router-link>
							<ul class="SousMenu">
							<li><router-link @click='desactiveRMenu()' class="lienActif" to="/dictionary">Liste des dictionnaires</router-link></li>
							<li><router-link @click='desactiveRMenu()' class="lienActif" to="/submission">Soumissions</router-link></li>
							</ul>
						</li>
						<li><router-link @click='desactiveRMenu()' class="lienActif" to="/typographie">Charte typographique</router-link>
							<!--
							<ul class="SousMenu">
								<li><router-link @click='desactiveRMenu()' class="lienActif" to="/typo_list">Liste des dictionnaires</router-link></li>
								<li><router-link @click='desactiveRMenu()' class="lienActif" to="/typo_actif">Dictionnaire typographique actif</router-link></li>
								<li><router-link @click='desactiveRMenu()' class="lienActif" to="/typo_except">Dictionnaires d'exceptions typographiques</router-link></li>
							</ul>
							-->
						</li>
						<li><router-link @click='desactiveRMenu()' to="/preferences/edit">Préférences</router-link>
							<ul class="SousMenu"  v-if="role == 'SUPERADMIN'">
								<li><router-link @click='desactiveRMenu()' class="lienActif" to="/preferences/edit">Édition</router-link></li>
								<li><router-link @click='desactiveRMenu()' class="lienActif" to="/preferences">Téléchargement</router-link></li>
							</ul>
						</li>
					</ul>
				</li>
				<li class="elementsMenu"><a class="lienActif" href="#">Extras</a>
					<ul class="MenuDropdown">
					<li>
						<ul class="SousMenu">
							<li ><router-link @click='desactiveRMenu()' class="lienActif" to="/documentation">Documentation</router-link></li>
							<li v-if="role == 'SUPERADMIN' ||  role == 'ADMIN'"><router-link @click='desactiveRMenu()' class="lienActif" to="/plugin">Plug-in Js</router-link></li>
							<li><router-link @click='desactiveRMenu()' class="lienActif" to="/test">Page de test</router-link></li>
						</ul>
					</li>
					</ul>
				</li>
			</ul>
			<div id="titleConfig" v-if="isConfigActive()">Configuration {{this.$store.getters.setting.name}}</div>
			<div id="resfrehConfigBtn" v-if="this.$route.meta.showRefreshConfigBtn && isConfigActive()">
				<button id="btnRefresh" class="lienActif boutonTableau" @click="refreshConfig()" :disabled="!configHasModifSuperADMIN">
					Envoyer les modifs
					<span class="material-icons notification" v-if="configHasModif">notifications</span>
				</button>
			</div>
        </div>
    </header>
</template>

<script>
	import axios from 'axios';
	import { diagonalbackURL, defaultConfig } from "../constantes";
	import FctUtils from '@/components/FctUtils';

    export default {
        name: "headerPl",
		mixins: [FctUtils],

        data() {
            return {
                defaultUser:"",
				isRMenuActive:false,
            }
        },
        computed:{
            myVersion() { return process.env.VUE_APP_VERSION },
            user() {
                var result = this.defaultUser;
                if(this.$store.state.currentUser != undefined && this.$store.state.currentUser.name != undefined) {
                    result = this.$store.state.currentUser.firstName + " " + this.$store.state.currentUser.name;
                }
                // else if(this.$store.state.currentUser != undefined && this.$store.state.currentUser == -1) {
                //     result = "Toto";
                // }
                return result 
            },
            role() {
                return this.$store.state.currentUser.role;
            },
            hasAdminRight() {
                return ['SUPERADMIN','ADMIN'].indexOf(this.role) != -1;
            },
            hasSuperAdminRight() {
                return ['SUPERADMIN'].indexOf(this.role) != -1;
            },
			computShowConfig() {
				var data = this.showConfig();

				return data;
			},
			configHasModif() {
				return this.$store.getters.compteur != 0;// || this.hasSuperAdminRight;	
			},
			configHasModifSuperADMIN() {
				return this.$store.getters.compteur != 0 || this.hasSuperAdminRight;	
			},
			divBtnRMenuClass() {
				var rMenuClass = "";
				if (this.isRMenuActive)  rMenuClass += 'showRMenu '; 
				if(this.$route.meta.showRefreshConfigBtn && this.isConfigActive()) rMenuClass += " activateRMenu ";
				return rMenuClass;
			},
        },
        methods : {
            logout: function () {
                this.$store.commit('logout', {router:this.$router});
            }, 
			showConfig() {
				if (this.$store.state.settings.length == 1) return false;
				return true;
			},
			configID() {
				return (this.noEmpty(this.$store.state.setting)) ?'' : 'configListe';
			},
			isConfigActive() {
				return (this.$store.getters.setting && this.$store.getters.setting != -1)
			},
			hasAdminRight(role) {
                return ['SUPERADMIN','ADMIN'].indexOf(role) != -1;
            },
			refreshConfig() {
				const self = this;
				const setting = this.$store.getters.setting;
				const defConfig = defaultConfig;
				const diagURL   = diagonalbackURL;


				axios.post(diagURL + "/settings/"+ setting.id + "/refresh", null, defConfig)
				.then(reponse => {
					const sStore = self.$store;

					sStore.dispatch('changeCompteur', 0);

					// On viens de changer les settings, il faut reactualiser aprés le loadSettings
					// De plus si SUPERADMIN, cela nous permet de revenir vers la Configuration precedente
					//
					sStore.dispatch('loadSettings')
					.then(function() {
						var findSett = false;

						// Cas Admin, on regarde si la configuration avant le click sur le bouton
						//  se trouve dans celles associées au client
						//
						if (sStore != undefined && sStore.getters.settings != undefined) {
							for (var i = 0; i < sStore.getters.settings.length; i++) {
								var sett = sStore.getters.settings[i];
								if (sett.id  == setting.id && !findSett) {
									sStore.dispatch('chooseSetting', sett);
									if (self.hasSuperAdminRight) console.log("ADMIN : Change Setting : " + sett.name)
									findSett = true;
								}
							}
						}

						// Cas SUPERADMIN : l'ancienne configuration n'a pas été trouvé dans celle associée au client, 
						// On regarde donc parmis toutes les configurations disponibles, tous clients confondus
						//
						if (!findSett && self.hasSuperAdminRight) {
							axios(diagURL + "/settings", defConfig)
							.then(response => {
								var allsettings = response.data;

								for (var y = 0; y < allsettings.length; y++) {
									var sett = allsettings[y];

									if (sett.id  == setting.id && !findSett) {
										sStore.dispatch('chooseSetting', sett);
										findSett = true;
										if (self.hasSuperAdminRight) console.log("SUPERADMIN Change Setting : " + sett.name)
									}
								}
							})
							.catch(error => self.errorHandler(error));
						}
					});
				})
				.catch(async error => {
					const errorCatched = await FctUtils.methods.areSettingsLocked(error);

					if (!errorCatched) {
						FctUtils.methods.errorHandler(error); 
						this.emitter.emit('showPopup', {mode: 'error_refresh'});
					}
					else {
						this.emitter.emit('showPopup', {mode: 'error_maj'});
					}
				});
			},
			toAdmin() {
				// En tant qu'Admin, on va directement sur la page client correspondante
				var url = "/clients/" + this.$store.getters.clientId

				// En tant que SUPERADMIN, 2 cas :
				// -> Si pas de configuration, on va sur la page client associé au SUPERADMIN (Diagonal)
				// -> Si config en cours, on va sur la page du client de la config
				if (this.role == 'SUPERADMIN' && this.noEmpty(this.$store.getters.setting)) {
					url = "/clients/" + this.$store.getters.setting.clientId
				}
				return url;
			},
			desactiveRMenu() {
				this.isRMenuActive = false;
			},
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/**
* Feuille de style principale de la partie admin du WebService.
**/

.mdl-layout__content {
    padding: 0;
    margin: 0;
}


.mdl-typography--display-4, .mdl-typography--display-4-color-contrast,
.mdl-typography--display-3, .mdl-typography--display-3-color-contrast,
.mdl-typography--display-2, .mdl-typography--display-2-color-contrast,
.mdl-typography--display-1, .mdl-typography--display-1-color-contrast {
	font-family: "Titillium Web", Arial, Helvetica, sans-serif;
}

.mdl-typography--headline, .mdl-typography--headline-color-contrast,
.mdl-typography--title, .mdl-typography--title-color-contrast,
.mdl-typography--subhead, .mdl-typography--subhead-color-contrast,
.mdl-typography--body-1-force-preferred-font,
.mdl-typography--body-1-force-preferred-font-color-contrast, 
.mdl-typography--caption-force-preferred-font-color-contrast, .mdl-typography--menu, 
.mdl-typography--menu-color-contrast, .mdl-typography--button, .mdl-typography--button-color-contrast{
	font-family: "Titillium Web", Arial, Helvetica, sans-serif;
}

.mdl-badge[data-badge]:after, .mdl-button, .mdl-chip {
	font-family: "Titillium Web", Arial, Helvetica, sans-serif;
}


.mdl-list__item, .mdl-layout__title, .mdl-layout-title, .mdl-layout__drawer-button {
	font-family: "Titillium Web", Arial, Helvetica, sans-serif;
}

.mdl-layout__header {
    height: 102px;
    width: 100%;
	background-color: #0075bb;
	transition-property: max-height, box-shadow;
	overflow: visible;
}

@media screen and (max-width:1024px) {
	.mdl-layout__header {
		height: 95px;
	}
}

/** LOGO **/
.mdl-layout__header-row {
    width: 100%;
	padding: 0 40px 0 80px;
	background: rgb(0,118,188);
	background: url("@/assets/images/PLWebService_logo.png"), linear-gradient(90deg, rgba(0,118,188,1) 0%, rgba(0,152,217,1) 40%, rgba(0,152,217,1) 100%);
	background-repeat: no-repeat;
	background-position: 8px center;
	background-size: 250px, auto;
	border-bottom-color: rgba(0,152,217,1);
	border-bottom-style: solid;
	border-bottom-width: thin;

	display: flex;
	margin: 0;
	padding: 0;
}

#version {
    display: block;
	margin: auto;
	margin-right: 19px;

    font-family: "Titillium Web", Arial, Helvetica, sans-serif;
	color: rgb(209, 241, 255);
	line-height: 14px;
	text-align: left;
	font-weight: 700;
	font-size: 15px;
}

#userlog {
	display: flex;
    margin: auto;
	margin-left: calc(max(250px, 40%));

    font-family: "Titillium Web", Arial, Helvetica, sans-serif;
	color: rgb(209, 241, 255);
	line-height: 14px;
	text-align: left;
	font-weight: 700;
	font-size: 15px;
}

#username {
	margin: auto;
	padding-right: 5px;
}

#logout {
	margin: auto;
	color :#cc0b00;
	cursor: pointer;
}


/** Bloc Menu Principal **/
#div_menu {
	display: flex;
	flex-wrap: wrap;
	height: 38px;
	overflow: visible;
}

.mdl-layout__tab-bar-button {
	background-color: #0075bb;
}

.mdl-layout__tab {
	line-height: 38px;
	overflow: visible;
}

.mdl-layout__tab-panel {
    background-color: #fff;
}

.mdl-snackbar, .mdl-snackbar__action, .mdl-textfield__input {
	font-family: "Titillium Web", Arial, Helvetica, sans-serif;
}


/** Gestion du Menu Principal **/
#menuPrincipal .lienActif {
	cursor: pointer;
}

#menuPrincipal {
	display: inline-block;
	position: relative;
	padding: 0;
	padding-left: 20px;
	margin: 0;
	overflow: visible;

	width: 420px;
}

#menuPrincipal a {
	cursor: default;
}

.elementsMenu {
	height: 38px;
	display: block;
	position: relative;
	float: left;
	padding: 0;
	margin: 0;
	overflow: visible;
}

.elementsMenu a {
	display: block;
	color: #fff;
	background-color: #0075bb;
	padding: 0;
	padding-left: 10px;
	padding-right: 10px;
	margin: 0;
	transition: all 0.5s ease;
	overflow: visible;
	text-decoration: none;
	line-height: 38px;
	text-align: center;
	font-weight: 500;
	font-size: 14px;
	text-transform: uppercase;
	color: rgba(255, 255, 255, .6);
	overflow: visible;
}

.elementsMenu a:hover {
	color: #fff;
	background-color: #00639f;
}

#menuPrincipal li ul.MenuDropdown {
	visibility: hidden;
	opacity: 0;
	position: absolute;
	transition: all 0.8s ease;
	margin: 0;
	margin-top: 0px;
	padding-left: 0;
	left: 0;
	z-index: 100;
	display: none;
}

#menuPrincipal li:hover>ul.MenuDropdown {
	visibility: visible;
	opacity: 1;
	display: block;
}

/** Sous-Menu **/
.MenuDropdown {
	background-color: #0089db;
	
}

.MenuDropdown li {
	line-height: 10px;
}

.MenuDropdown li a {
	display: block;
	color: #fff;
	background-color: #0089db;
	padding: 0;
	padding-left: 20px;
	padding-right: 20px;
	margin: 0;
	transition: all 0.5s ease;
	overflow: visible;
	text-decoration: none;
	line-height: 38px;
	text-align: left;
	font-weight: 500;
	font-size: 11px;
	text-transform: uppercase;
	color: rgba(255, 255, 255, 1);
	border-top-color: #1799e6;
	border-top-width: 1px;
	border-top-style: solid;
}


.MenuDropdown li a:hover {
	color: #fff;
	background-color: #00639f;
}

.MenuDropdown li, .SousMenu li {
	list-style: none;
	white-space: nowrap;
	padding: 0;
	margin: 0;
}

/** Sous-Menu niveau 2 **/
.SousMenu {
	padding-left: 0px;
}

.SousMenu li:first-child a {
	border-top-width: 1px;
}

.SousMenu li a {
	display: block;
	color: #fff;
	background-color: #48adea;
	padding: 0;
	padding-left: 35px;
	padding-right: 20px;
	margin: 0;
	transition: all 0.5s ease;
	overflow: visible;
	text-decoration: none;
	line-height: 28px;
	text-align: left;
	font-weight: 500;
	font-size: 12px;
	text-transform: none;
	color: rgba(255, 255, 255, 1);

	border-top-color: #1799e6;
    border-top-width: 1px;
    border-top-style: solid;
}

.SousMenu li a:hover {
	color: #fff;
	background-color: #0079c3;
}


#configListe {
	
	font-weight: bold;
}


#titleConfig {
	flex: 2;

	margin: auto;
	text-align: center;
}

#resfrehConfigBtn {
	width: 204px;
	padding-right: 19px;

	margin: auto;
	text-align: end;
}

#btnRefresh:active:not([disabled]) {
	transform: translateY(4px);
}


#btnRefresh .notification {
  position: absolute;
  top: -5px;
  right: -5px;
  padding: 3px 5px;
  border-radius: 50%;
  background-color: red;
  color: white;
  font-size:20px;
}

#div_btn_showRMenu {
	display: none;
}

/* Petit écran */

@media screen and (min-width:480px) and (max-width:862px) {
	#div_btn_showRMenu.activateRMenu {
		display: flex;
		margin: auto;
		padding-left: 18px;
	}

	#div_btn_showRMenu.activateRMenu + #menuPrincipal {
		display: none;
		flex:0;
		position: absolute;
		top: 39px;
	}

	#div_btn_showRMenu.showRMenu.activateRMenu + #menuPrincipal {
		display: inline-block;
	}

}

</style>
